export default function StripeAuthenticate({ stripeAuthenticate }: { stripeAuthenticate: boolean }) {
    if (stripeAuthenticate) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <img
                    src="https://chamcore.com/chameleon/uploads/templates/stripe_icon.png" // 🔥 replace with your Vipps logo path
                    alt="Stripe"
                    className="w-32 h-auto mb-6"
                />
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {"Åpne Stripe for å bekrefte betalingen"}
                </h3>
                <p className="text-gray-600 mb-6 max-w-sm">
                    {"Vent til Stripe autentiserer seg, så omdirigeres du til kassen."}
                </p>
                <div className="animate-pulse text-purple-600 font-medium">
                    {"Venter på bekreftelse…"}
                </div>
            </section>
        )
    }
}